module.exports = __webpack_public_path__ + "static/media/thumb-down-gold.6d422f3c.svg";